import GDPROptions from 'components/summary/GDPROptions/styled';

export default GDPROptions;
